// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderIcon_root__cg+14"};